import { defaultAxios, IParams } from './base';

export interface IFetchLoanPreviewPromotion extends IParams {
  promotionSeq: string;
  token: string;
}

export const fetchLoanPreviewPromotion = (
  params: IFetchLoanPreviewPromotion,
) => {
  return defaultAxios().post(`/loan/preview/promotion`, params);
};
